import { render, staticRenderFns } from "./EditRegistrationForm.vue?vue&type=template&id=4d9700be&scoped=true&"
import script from "./EditRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./EditRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./EditRegistrationForm.vue?vue&type=style&index=0&id=4d9700be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9700be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9700be')) {
      api.createRecord('4d9700be', component.options)
    } else {
      api.reload('4d9700be', component.options)
    }
    module.hot.accept("./EditRegistrationForm.vue?vue&type=template&id=4d9700be&scoped=true&", function () {
      api.rerender('4d9700be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/smsRegistrationComponents/EditRegistrationForm.vue"
export default component.exports